const HeroTertiary = (props) => {

  const {
    title,
    paragraph,
    imageShape,
    image,
    colorScheme
  } = props

  const normalizedData = {
    title,
    paragraph,
    imageShape,
    image: {
      alt: image.alternativeText,
      src: image.url
    },
    colorScheme
  }

  return normalizedData
}

export default HeroTertiary
